var v1="<span ng-if=\"!editMode\">{{score.putt_cnt }}</span><span ng-if=\"editMode\" class=\"column-input\"><span ng-change=\"valueUpdated(score, 'putt_cnt')\" gnp-custom-select=\"\" ng-model=\"score.putt_cnt\" disable=\"!isShotEntered(score)\" options=\"defaultData.puttOptions\" class=\"input gray\"></span></span>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-card/templates/putt.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/components/score-card/templates/putt.jade
// module id = 403
// module chunks = 0